'use strict'

angular
  .module('basalteApp')
  .constant('BAS_CALL_HISTORY', {
    EVT_CALL_HISTORY_UPDATED: 'callHistoryUpdated',
    EVT_CALL_HISTORY_ENTRY_IMAGES_UPDATED: 'callHistoryEntryImagesUpdated'
  })
